/**
 * Ontology helper — imperative (non-React) functions for building ontology
 * context strings from EditorStore state. Used in chat-model-adapter.ts.
 */

import { buildAppOntology } from '@/features/flow-editor/services/app-ontology'
import { mergeFlowsIntoBlocks } from '@/features/flow-editor/hooks/use-app-ontology'
import { buildOntologySystemPrompt } from '@cogo/webmcp-runtime'

/**
 * Build an ontology context string from a store snapshot.
 * Returns undefined if no blocks are loaded (app not ready).
 */
export function buildOntologyContextString(store: Record<string, any>): string | undefined {
  const blocks = store.app?.blocks
  if (!blocks || Object.keys(blocks).length === 0) return undefined

  try {
    const mergedBlocks = mergeFlowsIntoBlocks(blocks, store.flows ?? {})
    const ontology = buildAppOntology({ blocks: mergedBlocks })
    // Skip if ontology is empty
    if (
      ontology.datasources.length === 0 &&
      ontology.flows.length === 0 &&
      ontology.states.length === 0
    ) {
      return undefined
    }
    return buildOntologySystemPrompt(ontology)
  } catch {
    return undefined
  }
}

// Re-export for convenience
export { buildAppOntology as buildAppOntologyFromStore }
